jQuery(function($) {

  // Move mega menus from section to menu
  $('.site-nav__link').each(function () {
    const megaSlug = $(this).data('nav-item');
    if ($(`#mega-menu-${megaSlug}`).length) {
      $(`#mega-menu-${megaSlug}`).insertAfter(`#mega-menu-parent-${megaSlug}`);
      $(`#mega-menu-parent-${megaSlug}`).addClass('has-mega');
    }
  });

  // Remove all mega menu section divs after loading
  $('.mega-menu-section').remove();

  function createCompanyPerksController() {
    const marquee = document.querySelector('#header-nav__wrapper [data-company-perks-marquee]');

    if (!marquee) {
      return null;
    }

    const track = marquee.querySelector('.company-perks-marquee__track');
    const firstGroup = marquee.querySelector('.company-perks-marquee__group');
    const parkingMarker = document.createComment('company-perks-marquee');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const resumeDelay = (Number(marquee.dataset.resumeDelay) || 3) * 1000;
    let animation = null;
    let resumeTimeout = null;
    let resizeFrame = null;
    let pointerState = 'idle';
    let pointerId = null;
    let pointerStartX = 0;
    let pointerStartY = 0;
    let pointerLastX = 0;
    let pointerHovered = false;
    let focusWithin = false;

    marquee.parentNode.insertBefore(parkingMarker, marquee);

    function settingEnabled(value) {
      return value === 'true';
    }

    function getAnimation() {
      if (!track || typeof track.getAnimations !== 'function') {
        return null;
      }

      return track.getAnimations()[0] || null;
    }

    function clearResumeTimeout() {
      if (resumeTimeout) {
        window.clearTimeout(resumeTimeout);
        resumeTimeout = null;
      }
    }

    function pauseAnimation() {
      clearResumeTimeout();
      animation = getAnimation();

      if (animation) {
        animation.pause();
      }
    }

    function scheduleResume() {
      clearResumeTimeout();

      if (reducedMotion.matches || pointerHovered || focusWithin || pointerState === 'dragging') {
        return;
      }

      animation = getAnimation() || animation;

      if (!animation) {
        return;
      }

      resumeTimeout = window.setTimeout(function () {
        if (!pointerHovered && !focusWithin && pointerState !== 'dragging') {
          animation.play();
        }
        resumeTimeout = null;
      }, resumeDelay);
    }

    function activate(insertMarquee) {
      insertMarquee();
      marquee.hidden = false;
    }

    function hide() {
      marquee.hidden = true;
    }

    function placeMobile() {
      const scroll = document.getElementById('mega-menu__scroll');
      const mobileNav = document.getElementById('mobile-nav');

      if (!settingEnabled(marquee.dataset.mobileEnabled) || !scroll || !mobileNav) {
        hide();
        return;
      }

      activate(function () {
        mobileNav.insertAdjacentElement('afterend', marquee);
      });
    }

    function placeDesktop(menu) {
      const activeMenu = menu || document.querySelector('.mega-menu.mega-active');

      if (!settingEnabled(marquee.dataset.desktopEnabled) || !activeMenu) {
        hide();
        return;
      }

      activate(function () {
        activeMenu.appendChild(marquee);
      });
    }

    function refresh(menu) {
      if (window.innerWidth >= 1180) {
        placeDesktop(menu);
      } else {
        placeMobile();
      }
    }

    function animationDuration() {
      if (!animation || !animation.effect) {
        return 0;
      }

      const timing = animation.effect.getTiming();
      return typeof timing.duration === 'number' ? timing.duration : 0;
    }

    function normalizeTime(time, duration) {
      return ((time % duration) + duration) % duration;
    }

    function scrub(deltaX) {
      const groupWidth = firstGroup ? firstGroup.getBoundingClientRect().width : 0;
      const duration = animationDuration();

      if (!groupWidth || !duration || !animation) {
        return;
      }

      const currentTime = Number(animation.currentTime) || 0;
      const directionMultiplier = marquee.classList.contains('company-perks-marquee--left-to-right') ? 1 : -1;
      animation.currentTime = normalizeTime(
        currentTime + (directionMultiplier * deltaX / groupWidth * duration),
        duration
      );
    }

    function beginPointer(evt) {
      if (evt.pointerType === 'mouse' && evt.button !== 0) {
        return;
      }

      if (evt.pointerType === 'mouse' && evt.cancelable) {
        evt.preventDefault();
      }

      animation = getAnimation();

      if (!animation) {
        return;
      }

      pauseAnimation();
      pointerState = 'pending';
      pointerId = evt.pointerId;
      pointerStartX = evt.clientX;
      pointerStartY = evt.clientY;
      pointerLastX = evt.clientX;
    }

    function movePointer(evt) {
      if (pointerState === 'idle' || evt.pointerId !== pointerId || !animation) {
        return;
      }

      const totalX = evt.clientX - pointerStartX;
      const totalY = evt.clientY - pointerStartY;

      if (pointerState === 'pending') {
        if (Math.abs(totalX) < 6 && Math.abs(totalY) < 6) {
          return;
        }

        if (Math.abs(totalY) > Math.abs(totalX)) {
          pointerState = 'vertical';
          return;
        }

        pointerState = 'dragging';
        marquee.classList.add('is-dragging');

        if (typeof marquee.setPointerCapture === 'function') {
          marquee.setPointerCapture(evt.pointerId);
        }
      }

      if (pointerState !== 'dragging') {
        return;
      }

      if (evt.cancelable) {
        evt.preventDefault();
      }

      scrub(evt.clientX - pointerLastX);
      pointerLastX = evt.clientX;
    }

    function finishPointer(evt) {
      if (pointerState === 'idle' || (evt && typeof evt.pointerId === 'number' && evt.pointerId !== pointerId)) {
        return;
      }

      marquee.classList.remove('is-dragging');
      pointerState = 'idle';
      pointerId = null;
      scheduleResume();
    }

    function handlePointerEnter(evt) {
      if (evt.pointerType !== 'mouse' || !window.matchMedia('(hover: hover)').matches) {
        return;
      }

      pointerHovered = true;
      pauseAnimation();
    }

    function handlePointerLeave(evt) {
      if (evt.pointerType !== 'mouse') {
        return;
      }

      pointerHovered = false;
      scheduleResume();
    }

    function handleFocusIn() {
      focusWithin = true;
      pauseAnimation();
    }

    function handleFocusOut() {
      focusWithin = false;
      scheduleResume();
    }

    function handleNativeDrag(evt) {
      evt.preventDefault();
    }

    function handleResize() {
      if (resizeFrame) {
        window.cancelAnimationFrame(resizeFrame);
      }

      resizeFrame = window.requestAnimationFrame(function () {
        refresh();
        resizeFrame = null;
      });
    }

    function destroy() {
      clearResumeTimeout();
      marquee.removeEventListener('pointerdown', beginPointer);
      marquee.removeEventListener('pointerenter', handlePointerEnter);
      marquee.removeEventListener('pointerleave', handlePointerLeave);
      marquee.removeEventListener('focusin', handleFocusIn);
      marquee.removeEventListener('focusout', handleFocusOut);
      marquee.removeEventListener('dragstart', handleNativeDrag);
      window.removeEventListener('pointermove', movePointer);
      window.removeEventListener('pointerup', finishPointer);
      window.removeEventListener('pointercancel', finishPointer);
      window.removeEventListener('blur', finishPointer);
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('orientationchange', handleResize);

      if (parkingMarker.parentNode) {
        parkingMarker.parentNode.removeChild(parkingMarker);
      }
    }

    marquee.addEventListener('pointerdown', beginPointer);
    marquee.addEventListener('pointerenter', handlePointerEnter);
    marquee.addEventListener('pointerleave', handlePointerLeave);
    marquee.addEventListener('focusin', handleFocusIn);
    marquee.addEventListener('focusout', handleFocusOut);
    marquee.addEventListener('dragstart', handleNativeDrag);
    window.addEventListener('pointermove', movePointer, { passive: false });
    window.addEventListener('pointerup', finishPointer);
    window.addEventListener('pointercancel', finishPointer);
    window.addEventListener('blur', finishPointer);
    window.addEventListener('resize', handleResize);
    window.addEventListener('orientationchange', handleResize);
    refresh();

    return {
      destroy: destroy,
      hideDesktop: function () {
        if (window.innerWidth >= 1180) {
          hide();
        }
      },
      placeDesktop: placeDesktop,
      placeMobile: placeMobile,
      refresh: refresh
    };
  }

  function bootCompanyPerks() {
    if (window.wcsCompanyPerksController) {
      window.wcsCompanyPerksController.destroy();
    }

    window.wcsCompanyPerksController = createCompanyPerksController();
  }

  bootCompanyPerks();

  $(document)
    .off('shopify:section:load.companyPerks')
    .on('shopify:section:load.companyPerks', function (evt) {
      if (evt.target && (
        evt.target.id === 'shopify-section-header' ||
        evt.target.querySelector('[data-section-type="header-section"]')
      )) {
        window.setTimeout(bootCompanyPerks, 0);
      }
    });

  const hoverSuppressionKey = 'wcsMegaMenuHoverSuppression';
  let suppressedMenuSlug = null;

  try {
    suppressedMenuSlug = window.sessionStorage.getItem(hoverSuppressionKey);
  } catch (error) {
    // Continue with normal hover behavior if browser storage is unavailable.
  }

  function clearHoverSuppression() {
    suppressedMenuSlug = null;
    $('.site-nav__link').off('.megaHoverSuppression');
    $(document).off('.megaHoverSuppression');

    try {
      window.sessionStorage.removeItem(hoverSuppressionKey);
    } catch (error) {
      // Browser storage may be unavailable in private browsing contexts.
    }
  }

  if (suppressedMenuSlug) {
    const $suppressedMenuLink = $('.site-nav__link').filter(function () {
      return $(this).data('nav-item') === suppressedMenuSlug;
    }).first();

    if ($suppressedMenuLink.length) {
      $suppressedMenuLink.one('mouseleave.megaHoverSuppression', clearHoverSuppression);
      $(document).one('mousemove.megaHoverSuppression', function () {
        if (!$suppressedMenuLink.is(':hover')) {
          clearHoverSuppression();
        }
      });
    } else {
      clearHoverSuppression();
    }
  }

  $('.close-mega').on('click', function () {
    closeMegaMenu();
  });

  function closeMegaMenu() {
    $('header').removeClass('mega-active');
    $('.mega-menu').removeClass('mega-active');
    $('.site-nav__link').removeClass('mega-link-active');
    $('.mega-menu__content').removeClass('active');
    $('div.overlay').removeClass('visible');
    $('.mega-menu__content-wrapper .mega-menu__content:first-of-type').addClass('active');

    if (window.wcsCompanyPerksController) {
      window.wcsCompanyPerksController.hideDesktop();
    }
  }

  $('div.overlay').on('click', function() {
    closeMegaMenu();
  });

    // Prevent closing when hovering within the header
    $('header[role="banner"]').on('mouseleave', function () {
      closeMegaMenu();
    });
    //Desktop Hover
    $('.site-nav__link').on('mouseenter', function () {
      if ($(window).width() > 1179) { // Ensure hover is only for desktop 
        const menuSlug = $(this).data('nav-item');
        if (menuSlug === suppressedMenuSlug) {
          return;
        }

        if ($(`#mega-menu-${menuSlug}`).length) {
          // Remove transition for all mega menus
          $('.mega-menu').each(function () {
            this.style.setProperty('transition', 'none', 'important');
          });

          // Open the new menu
          $(`#mega-menu-${menuSlug}`).addClass('mega-active');

          if (window.wcsCompanyPerksController) {
            window.wcsCompanyPerksController.placeDesktop(document.getElementById(`mega-menu-${menuSlug}`));
          }
          $('.mega-menu__content').removeClass('active');
          $('.mega-menu__child_link').removeClass('active');
          $('.mega-menu__content-wrapper .mega-menu__content:first-of-type').addClass('active');
          $('div.overlay').addClass('visible');
          $('header').addClass('mega-active');
          $('.site-nav__link').removeClass('mega-link-active');
          $(this).addClass('mega-link-active');

          // Close other menus
          $('.mega-menu').not(`#mega-menu-${menuSlug}`).removeClass('mega-active');
        }
      }
    });

    // Adjust closing logic for menus
    $('.mega-menu').on('mouseleave', function () {
      if ($(window).width() > 1179) {
        // Check if still hovering on header
        if (!$('header[role="banner"]:hover').length) {
          closeMegaMenu();
          // Restore the transition property for all mega menus
          $('.mega-menu').each(function () {
            this.style.removeProperty('transition');
          });
        }
      }
    });

  // Hover interaction for child-link--has-submenu
  $('.child-link--has-submenu .mega-menu__child_link.has-children:not(.all-link)').on('mouseenter', function () {
    if ($(window).width() > 1179) { // Only trigger on desktop
      const menuSlug = $(this).data('link-item');
      const childSlug = $(this).data('child-link-item');

      if (!$(this).hasClass('active')) {
        $(`#mega-menu-${menuSlug} .mega-menu__child_link`).removeClass('active');
        $('.mega-menu__content').removeClass('active');
        $(`#mega-menu-${menuSlug} #mega-menu-content-${childSlug}`).addClass('active');
        $('#header-nav__wrapper').addClass('sub-menu-active');
        $(this).addClass('active');
      }
    }
  });

  // Desktop mega menus open on hover, so let top-level links navigate normally.
  // Keep the click-to-toggle behavior for narrower layouts.
  $('.site-nav__link').on('click', function (e) {
    const menuSlug = $(this).data('nav-item');
    if ($(`#mega-menu-${menuSlug}`).length) {
      if ($(window).width() > 1179) {
        try {
          window.sessionStorage.setItem(hoverSuppressionKey, menuSlug);
        } catch (error) {
          // Navigation should continue even if browser storage is unavailable.
        }
        return;
      }

      e.preventDefault();
      if ($(this).hasClass('mega-link-active')) {
        closeMegaMenu();
      } else {
        $('.mega-menu__content').removeClass('active');
        $('.mega-menu__child_link').removeClass('active');
        $('.mega-menu__content-wrapper .mega-menu__content:first-of-type').addClass('active');
        $('div.overlay').addClass('visible');
        $('header').addClass('mega-active');
        $('.site-nav__link').removeClass('mega-link-active');
        $(this).addClass('mega-link-active');
        $('.mega-menu').removeClass('mega-active');
        $(`#mega-menu-${menuSlug}`).addClass('mega-active');
      }
    }
  });

  // Existing mobile functionality remains untouched
  $('.mobile-nav-trigger').on('click', function (e) {
    e.preventDefault();
    console.log('clicked men')
    if (!$(this).hasClass('trigger-active')) {
      openMobileMenu();
    } else {
      closeMobileMenu();
    }
  });

  $('.mobile-search-btn').on('click', function (e) {
    e.preventDefault();
    console.log('clicked search')
    openMobileMenu();
    setTimeout( function() {
      $('#mobile-search input').focus()
    }, 500)
  })

  function sizeMobileMenu() {
    const viewportHeight = window.visualViewport ? window.visualViewport.height : window.innerHeight;
    let headerHeight = $('header').outerHeight();
    const mobileSearchHeight = $('#mobile-search').outerHeight();
    const alertHeight = $('#alert-bar').length ? $('#alert-bar').outerHeight() : 0;
    const countdownHeight = $('.countdown-text').length ? $('.countdown-text').outerHeight() : 0;
    headerHeight += alertHeight + countdownHeight;

    const drawerHeight = Math.max(viewportHeight - headerHeight, 0);
    const menuHeight = Math.max(drawerHeight - mobileSearchHeight, 0);
    const heightOffset = headerHeight + mobileSearchHeight;

    $('#header-nav__wrapper, .findify-layouts--autocomplete--dropdown').css({
      height: `${drawerHeight}px`,
      top: `${headerHeight}px`
    });
    $('#mega-menu__outer').css('height', `${menuHeight}px`);
    $('.mega-menu__content:not(.mega-menu__content-images)').height(Math.max(viewportHeight - heightOffset, 0));
  }

  function openMobileMenu() {
    $('.mobile-nav-trigger').addClass('trigger-active');
    $('#header-nav__wrapper').show();
    $('header').addClass('mega-active');
    $('body').addClass('no-scroll');
    $('#mobile-menu').hide();
    sizeMobileMenu();
    $('#header-nav__wrapper').removeClass('sub-menu-active').addClass('active');

    if (window.wcsCompanyPerksController) {
      window.wcsCompanyPerksController.placeMobile();
    }
  }

  $(window)
    .off('resize.mobileMegaMenu orientationchange.mobileMegaMenu')
    .on('resize.mobileMegaMenu orientationchange.mobileMegaMenu', function () {
      if ($(window).width() < 1180 && $('#header-nav__wrapper').hasClass('active')) {
        sizeMobileMenu();
      }
    });

  if (window.visualViewport) {
    if (window.wcsMobileMenuViewportResizeHandler) {
      window.visualViewport.removeEventListener('resize', window.wcsMobileMenuViewportResizeHandler);
    }

    window.wcsMobileMenuViewportResizeHandler = function () {
      if ($(window).width() < 1180 && $('#header-nav__wrapper').hasClass('active')) {
        sizeMobileMenu();
      }
    };
    window.visualViewport.addEventListener('resize', window.wcsMobileMenuViewportResizeHandler);
  }

  function closeMobileMenu() {
    $('.mobile-nav-trigger').removeClass('trigger-active');
    $('#header-nav__wrapper').removeClass('active');
    $('.mega-menu').slideUp();
    $('.mega-menu__mobile-link').removeClass('active');
    $('#header-nav__wrapper').removeClass('sub-menu-active');
    $('body').removeClass('no-scroll');
  }

  $('.mega-menu__mobile-link.has-mega').on('click', function (e) {
    e.preventDefault();
    const $menuItem = $(this);
    $('.mega-menu').not($(this).next('.mega-menu')).slideUp();
    $(this).next('.mega-menu').slideToggle(300);
    // put sub menu in view
    setTimeout(function () {
      $('#mega-menu__scroll').animate({ scrollTop: $('#mega-menu__scroll').scrollTop() + $($menuItem).position().top - 10 });
    }, 550);
    $(this).toggleClass('active');
  });

  $('.child-link--has-submenu .mega-menu__child_link.has-children:not(.all-link)').on('click', function (e) {
    // Hover reveals the collection on desktop; clicking should follow its link.
    if ($(window).width() > 1179) {
      return;
    }

    e.preventDefault();
    const menuSlug = $(this).data('link-item');
    const childSlug = $(this).data('child-link-item');

    if ($(this).hasClass('active')) {
      const $imagesDiv = $(this).closest('.mega-menu').find('.mega-menu__content-images');
      if ($imagesDiv.length) {
        $(this).removeClass('active');
        $(`#mega-menu-${menuSlug} .mega-menu__child_link`).removeClass('active');
        $('.mega-menu__content').removeClass('active');
        $imagesDiv.addClass('active');
        $('#header-nav__wrapper').removeClass('sub-menu-active');
      }
    } else {
      $(`#mega-menu-${menuSlug} .mega-menu__child_link`).removeClass('active');
      $('.mega-menu__content').removeClass('active');
      $(`#mega-menu-${menuSlug} #mega-menu-content-${childSlug}`).addClass('active');
      $('#header-nav__wrapper').addClass('sub-menu-active');
      $(this).addClass('active');
    }
  });

  $('.prev-child-menu').on('click', function () {
    $('#header-nav__wrapper').removeClass('sub-menu-active');
    setTimeout(function () {
      // reset position of child scroll
      $('.mega-menu__content-inner').scrollTop(0);
      $('.mega-menu__content:not(.mega-menu__content-images)').hide();
    }, 500);
  });

  // $('#nav-search').on('click', function () {
  //   $('#search').toggleClass('active');
  //   if ($('#search').hasClass('active')) {
  //     setTimeout(function () {
  //       $('#search input').focus();
  //     }, 1000);
  //   }
  // });

  $(window).scroll(function () {
    $('#search').removeClass('active');
  });

  const mobileSearchForm = document.querySelector('#mobile-search form');
  mobileSearchForm.addEventListener("submit", function() {
    if (window.location.href.indexOf("search-results") > -1) {
      closeMobileMenu();
    }
  });
});
